function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_31",
  "data-name": "Group 31",
  transform: "translate(-578.352 -341.714)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_26",
  "data-name": "Group 26",
  transform: "translate(599.592 378.566)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_69",
  "data-name": "Rectangle 69",
  width: 3.717,
  height: 21.365,
  transform: "translate(2.074 0)",
  fill: "#fdc00f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_44",
  "data-name": "Path 44",
  d: "M636.375,478.86a1.3,1.3,0,0,1-1.388,1.18H629.9a1.3,1.3,0,0,1-1.388-1.18v-1.442a1.3,1.3,0,0,1,1.388-1.18h5.089a1.3,1.3,0,0,1,1.388,1.18Z",
  transform: "translate(-628.51 -458.675)",
  fill: "#fdc00f"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_29",
  "data-name": "Group 29",
  transform: "translate(593.202 398.493)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_70",
  "data-name": "Rectangle 70",
  width: 20.645,
  height: 17.627,
  rx: 3,
  transform: "translate(0 0)",
  fill: "#ffd633"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_28",
  "data-name": "Group 28",
  transform: "translate(4.424 3.331)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_71",
  "data-name": "Rectangle 71",
  width: 11.797,
  height: 9.717,
  rx: 3,
  fill: "#f9b233"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_27",
  "data-name": "Group 27",
  transform: "translate(1.966 2.106)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_45",
  "data-name": "Path 45",
  d: "M636.375,496.466a.393.393,0,0,1-.393.393H628.9a.393.393,0,0,1-.393-.393h0a.393.393,0,0,1,.393-.393h7.078a.393.393,0,0,1,.393.393Z",
  transform: "translate(-628.51 -496.073)",
  fill: "#fc0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_46",
  "data-name": "Path 46",
  d: "M636.375,500.466a.393.393,0,0,1-.393.393H628.9a.393.393,0,0,1-.393-.393h0a.393.393,0,0,1,.393-.393h7.078a.393.393,0,0,1,.393.393Z",
  transform: "translate(-628.51 -498.5)",
  fill: "#fc0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_47",
  "data-name": "Path 47",
  d: "M636.375,504.466a.393.393,0,0,1-.393.393H628.9a.393.393,0,0,1-.393-.393h0a.393.393,0,0,1,.393-.393h7.078a.393.393,0,0,1,.393.393Z",
  transform: "translate(-628.51 -500.927)",
  fill: "#fc0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_48",
  "data-name": "Path 48",
  d: "M636.375,508.466a.393.393,0,0,1-.393.393H628.9a.393.393,0,0,1-.393-.393h0a.393.393,0,0,1,.393-.393h7.078a.393.393,0,0,1,.393.393Z",
  transform: "translate(-628.51 -503.354)",
  fill: "#fc0"
})))), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_72",
  "data-name": "Rectangle 72",
  width: 31.655,
  height: 7.708,
  rx: 2,
  transform: "translate(587.697 414.321)",
  fill: "#3d9ae2"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_30",
  "data-name": "Group 30",
  transform: "translate(580.852 344.214)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_49",
  "data-name": "Path 49",
  d: "M589.477,387.322l2.7-15.6-11.322-11.065,15.669-2.256,7.025-14.187,6.987,14.206,15.664,2.3-11.352,11.035,2.656,15.606-14-7.385Z",
  transform: "translate(-580.852 -344.214)",
  fill: "#ffd633",
  stroke: "#fdc00f",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_50",
  "data-name": "Path 50",
  d: "M609.089,394.022l1.618-9.36-6.793-6.639,9.4-1.353,4.215-8.512,4.193,8.524,9.4,1.378-6.811,6.621,1.593,9.364-8.4-4.431Z",
  transform: "translate(-594.845 -358.742)",
  fill: "#fdc00f"
})));

var SvgRank3 = function SvgRank3(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50.346,
    height: 80.314,
    viewBox: "0 0 50.346 80.314",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRank3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rank-3.f48d9f95.svg";
export { ForwardRef as ReactComponent };